import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { GiftSupportPage } from "@/features/gift-support";

export const Route = createFileRoute("/gifts/")({
  component: GiftSupportRoute,
});

function GiftSupportRoute() {
  return (
    <AdminDashboardShell>
      <GiftSupportPage />
    </AdminDashboardShell>
  );
}
